import { ApiSlugs, ListPagination, SubscriptionId, SubscriptionSummaryDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserSubscriptionsAdminConnector extends ApiConnector<
  SubscriptionSummaryDto,
  SubscriptionSummaryDto,
  SubscriptionId
> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.SUBSCRIPTIONS}`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<SubscriptionSummaryDto[]> =>
      this.apiCaller.getRequest<SubscriptionSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
